import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import {
    FaIndustry,
    FaSeedling,
    FaUsers
} from "react-icons/fa";

const CompanyOverview = () => {
    return (
        <section className="section company-overview-section">
            <Container>

                {/* Section Title (common heading style reused) */}
                <div className="section-title fade-up">
                    <h2>Who We Are</h2>
                    <p>
                        Understanding our purpose, our approach, and our commitment
                        to Indian agriculture.
                    </p>
                </div>

                <Row className="align-items-center">

                    {/* LEFT CONTENT */}
                    <Col lg={7} className="fade-up">
                        <div className="overview-content">
                            <p>
                                Hindustan Agro Life is a professionally managed agricultural
                                solutions company focused on developing, manufacturing, and
                                delivering high-quality crop care and plant nutrition products
                                for Indian farmers.
                            </p>

                            <p>
                                Our product portfolio includes bio-based fertilizers,
                                plant nutrition solutions, growth enhancers, micronutrients,
                                and eco-friendly crop protection inputs designed to perform
                                under diverse soil and climatic conditions.
                            </p>

                            <p>
                                By combining field-level understanding with modern agricultural
                                science, we aim to support sustainable farming practices,
                                improved crop performance, and long-term soil health.
                            </p>

                            {/* Highlight points */}
                            <div className="overview-points">
                                <div className="point">
                                    <FaIndustry />
                                    <span>Professionally Managed Operations</span>
                                </div>
                                <div className="point">
                                    <FaSeedling />
                                    <span>Focus on Sustainable & Safe Farming</span>
                                </div>
                                <div className="point">
                                    <FaUsers />
                                    <span>Farmer-First Development Approach</span>
                                </div>
                            </div>
                        </div>
                    </Col>

                    {/* RIGHT IMAGE */}
                    <Col lg={5} className="fade-up">
                        <div className="overview-image mt-3">
                            <img
                                src="/images/img/company-overview.png"
                                alt="Hindustan Agro Life Overview"
                                className="img-fluid"
                            />
                        </div>
                    </Col>

                </Row>

            </Container>
        </section>
    );
};

export default CompanyOverview;
